export { default } from './CTA';
export type { CTAProps } from './CTA';
